/** Build a shareable chat URL. Omit chatId for the new-chat landing view. */
export function chatPath(chatId = null) {
  if (chatId != null && chatId !== "") {
    return `/chat/${chatId}`;
  }
  return "/chat";
}

/** Parse pathname into chat navigation state. */
export function parseChatLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "chat") {
    return { chatId: null };
  }
  return { chatId: parts[1] || null };
}
